module.exports = __webpack_public_path__ + "static/Testimonial1-d78dc035b099dd124b61ce9b97a768c7.jpg";